import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Classes, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Carousel ----------

	$('.content-section .section-carousel, .content-section .column-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				slidesPerView: 'auto',
				modules: [Navigation],
				spaceBetween: 30,
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Dropdown ----------
	$('.text-image-dropdown-section').each(function() {
		const buttons = this.querySelectorAll('.dropdown-button');
		const images = this.querySelectorAll('.dropdown-image');
		const firstImage = this.querySelector('.dropdown-image-initial')

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				const dataImage = button.getAttribute('data-image');
				const isCollapsed = button.classList.contains('collapsed');
				const imageToToggle = this.querySelector(`.${dataImage}`);

				images.forEach(image => image.classList.remove('show'));

				if(!isCollapsed && imageToToggle) {
					imageToToggle.classList.add('show');
				}

				const allCollapsed = [...buttons].every((btn) =>
					btn.classList.contains('collapsed')
				);

				if(allCollapsed && firstImage) {
					firstImage.classList.add('show');
				}
				else if(firstImage) {
					firstImage.classList.remove('show');
				}
			})


		})

	});

});
